/**
 * @typedef {import('../types').ChatMessage} ChatMessage
 */

/**
 * Sorts messages by their creation date in ascending order (oldest first)
 * @param {ChatMessage[]} messages - Array of chat messages to sort
 * @returns {ChatMessage[]} Sorted array of messages
 */
const sortMessagesByCreatedAt = (messages) => {
  if (!Array.isArray(messages) || messages.length === 0) {
    return messages;
  }

  return [...messages].sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return dateA - dateB;
  });
};

export { sortMessagesByCreatedAt };
